module.exports = __webpack_public_path__ + "static/pemalex_logo_clientes_delamore-d5c35fad81286a8a31e64e0f37491e20.png";